import { DSNCFaqSubmission } from 'shared-definitions/types'
import { ApiComponentFaqSubmission } from 'data-source/types.wp'

export function ncFaqSubmission(input: ApiComponentFaqSubmission): DSNCFaqSubmission {
  return {
    resource: 'nc-faq-submission',
    limit: input.character_limit ?? null,
    postId: input.post_id,
    buttonLabel: input.label,
    placeholder: input.placeholder,
    title: input.title,
  }
}
